<template>
	<div style="position: relative;">
	    <transition name="vue-table-loader">
	        <div class="vue-table-loader" v-if="loading">
                <span class="fa fa-cog fa-spin fa-3x"></span>
            </div>
	    </transition>
		<div class="row">
			<div class="col-md-4">
				<base-filter-bar :placeholder="!savedSearch ? 'Search Projects' : 'Search saved search'"></base-filter-bar>
			</div>
			<div class="col-md-8">
				<base-select-visible :per-page="perPage" :amounts-shown="amountsShown"></base-select-visible>
			</div>
		</div>
		<div class="dataTables_wrapper container-fluid dt-bootstrap4 modern">
		    <vuetable ref="vuetable"
				:api-url="apiUrl"
				:fields="fields"
				:css="css.table"
				:per-page="perPage"
				:append-params="moreParams"
				:noDataTemplate="!savedSearch ? 'Search Projects' : 'Search saved search'"
				pagination-path=""
				@vuetable:pagination-data="onPaginationData"
				@vuetable:loaded="onLoaded"
		    >
                <template slot="actions" slot-scope="props">
                    <div class="project-listing__item-actions">
                        <button
                            class="btn btn-danger btn-actions"
                            @click.prevent="confirmDelete(props.rowData.id)">
                            Delete
                        </button>
                        <a v-if="props.rowData.user_saved_search"
                            class="btn btn-primary"
                            :href="'/products/?project='+ props.rowData.id + '&search_id=' + props.rowData.user_saved_search_id + '&name=' + props.rowData.name + '&desc=' + props.rowData.desc +'&query=' + props.rowData.user_saved_search.data">
                            View
                        </a>
                        <a v-else class="btn btn-primary" :href="'/projects/' + props.rowData.id + '/edit'">
                            View
                        </a>
                    </div>
		    	</template>
		    </vuetable>
		    <div class="row">
		    	<div class="col-md-6">
		    		<base-pagination-info
		    			:css="css.table"
		    			ref="paginationInfo"
		    		>
		    		</base-pagination-info>
		    	</div>
		    	<div class="col-md-6">
		    		<base-pagination  ref="pagination"
		    		  @vuetable-pagination:change-page="onChangePage"
		    		></base-pagination>
		    	</div>
		    </div>
		</div>
	</div>
</template>

<style scoped lang="scss">
.project-listing__item-actions {
    display: inline-flex;
    align-items: center;
    justify-content: center;
}
.btn-actions {
    margin-right: 0.5rem;
}
</style>

<script type="text/javascript">
var base_url = window.location.protocol + "//" + window.location.host;

import Vue from "vue";
import VueEvents from "vue-events";
import BaseFilterBar from "../tables/base-filter-bar.vue";
import BasePagination from "../tables/base-pagination.vue";
import BasePaginationInfo from "../tables/base-pagination-info.vue";
import BaseSelectVisible from "../tables/base-select-visible.vue";
import axios from "axios";

Vue.use(VueEvents);

export default {
    name: "ProjectsListing",
    props: ['endpoint', 'savedSearch'],
    components: {
        "base-filter-bar": BaseFilterBar,
        "base-pagination": BasePagination,
        "base-pagination-info": BasePaginationInfo,
        "base-select-visible": BaseSelectVisible
    },
    data() {
        return {
            apiUrl: `${base_url}/${this.endpoint}`,
            perPage: 10,
            moreParams: {},
            loading: true,
            fields: [
                {
                    name: "name",
                    title: "Name",
                    sortField: "name"
                },
                {
                    name: "desc",
                    title: "Description"
                },
                {
                    name: "product_count",
                    title: "Products"
                },
                {
                    name: "__slot:actions",
                    titleClass: "actions-single-column"
                }
            ],
            amountsShown: [
                { text: "10", value: 10 },
                { text: "25", value: 25 },
                { text: "50", value: 50 },
                { text: "100", value: 100 }
            ],
            css: {
                table: {
                    tableClass:
                        "table table-striped table-bordered table-middle",
                    ascendingIcon: "sort-icon-asc",
                    descendingIcon: "sort-icon-desc",
                    infoClass: ""
                }
            }
        };
    },
    mounted() {
        this.$events.$on("per-page", eventData => this.doVisibleSet(eventData));
        this.$events.$on("filter-set", eventData =>
            this.onFilterSet(eventData)
        );
        this.$events.$on("filter-reset", e => this.onFilterReset());
    },
    watch: {
        perPage(val, oldVal) {
            this.$nextTick(function() {
                this.$refs.vuetable.refresh();
            });
        }
    },
    methods: {
        onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData);
            this.$refs.paginationInfo.setPaginationData(paginationData);
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        doVisibleSet(perPageValue) {
            this.perPage = perPageValue;
            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },
        onFilterSet(filterText) {
            this.moreParams = {
                filter: filterText
            };
            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },
        onFilterReset() {
            this.moreParams = {};
            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },
        onLoaded: function() {
            this.loading = false;
        },
        confirmDelete(projectId) {
            const userConfirmed = confirm("Are you sure you want to delete this project?");

            if (userConfirmed) {
                this.deleteProject(projectId);
            }
        },
        deleteProject(projectId) {
            this.showLoading = true;

            axios
                .delete(`${base_url}/pimapi/projects/${projectId}`)
                .then(response => {
                    window.location.reload();

                    this.showLoading = false;
                })
                .catch(error => {
                    this.showLoading = false;
                });
        }
    }
};
</script>
